import { Component } from '@angular/core';
import { LocalizeService } from '../../insa-services';
import {
  CommonField,
  createCheckboxField,
  createDatePickerField,
  createDropdownField,
  createEntityPickerField,
  createFilePickerField,
  createMailButtonField,
  createTextboxField,
} from './generic-editor/models/Field';
import { FieldGroupDefinition, makeFieldGroup } from './generic-editor/models/FieldGroup/FieldGroup';

@Component({
  selector: 'example-form',
  styles: [`
  :host {
    display: flex;
    flex-direction: columns;
    overflow: hidden;
  }
  `],
  template:
    '<generic-editor [canEdit]="false" [canDelete]="false" [fieldGroups]="fieldGroups"></generic-editor>',
})
export class ExampleFormComponent {

  constructor(private localization: LocalizeService) {
  }

  fieldGroups: FieldGroupDefinition[] = [
    makeFieldGroup({
      isVisible: true,
      fields: [
        createDropdownField({
          key: 'dropdown-x',
          value: '',
          label: 'dropdown',
          items: [
            { value: 'item1', label: 'item1' },
            { value: 'item2', label: 'item2' },
            { value: 'item3', label: 'item3' },
          ],
          rules: {
            required: {},
          },
          dataType: 'string',
        }),
        createEntityPickerField({
          key: 'entity-picker-x',
          value: '',
          label: 'entity-picker',
          rules: {
            required: {},
          },
          dataType: 'string',
        }),
      ]
    }, { localize: this.localization.getLocalizedResource }),
    makeFieldGroup({
      name: 'personalInformation',
      label: 'Personal information',
      isVisible: () => true,
      isHeaderVisible: true,
      description: 'Blah blah blah',
      fieldsPerLine: 3,
      renderingDirection: 'horizontal',
      fields: [
        createTextboxField({
          key: 'textbox2',
          value: '',
          label: 'Textbox2 (number | real)',
          rules: {
            required: {},
          },
          order: 2,
          dataType: 'number',
          fractionalLength: 2,
        }),
        createTextboxField({
          key: 'textbox3',
          value: '',
          label: 'Textbox3 (number | integer)',
          rules: {
            required: {},
          },
          order: 3,
          dataType: 'number',
        }),
        createCheckboxField({
          key: 'checkbox',
          value: '',
          label: 'checkbox',
          rules: {
            requiredTrue: {},
          },
          order: 4,
          dataType: 'string',
        }),
        createDatePickerField({
          key: 'date-picker',
          value: '',
          label: 'date-picker',
          rules: {
            required: {},
          },
          order: 5,
          dataType: 'date',
        }),
        createDropdownField({
          key: 'dropdown',
          value: '',
          label: 'dropdown',
          items: [
            { value: 'item1', label: 'item1' },
            { value: 'item2', label: 'item2' },
            { value: 'item3', label: 'item3' },
          ],
          rules: {
            required: {},
          },
          order: 6,
          dataType: 'string',
        }),
        createEntityPickerField({
          key: 'entity-picker',
          value: '',
          label: 'entity-picker',
          rules: {
            required: {},
          },
          order: 7,
          dataType: 'string',
        }),
        createFilePickerField({
          key: 'file-picker',
          file: {},
          label: 'file-picker',
          rules: {
            required: {},
          },
          order: 8,
          dataType: 'string',
        }),
        createMailButtonField({
          key: 'mail-button',
          value: '',
          label: 'mail-button',
          rules: {
            required: {},
          },
          order: 9,
          dataType: 'string',
        }),
      ]
    }, { localize: this.localization.getLocalizedResource }),
    makeFieldGroup({
      name: 'contactInformation',
      label: 'Contact Information',
      isVisible: () => true,
      isHeaderVisible: true,
      description: 'Blah blah blah',
      fieldsPerLine: 5,
      renderingDirection: 'vertical',
      fields: [
        createTextboxField({
          key: 'firstName',
          value: '',
          label: 'First name',
          rules: {
            required: {},
          },
          order: 10,
          dataType: 'string',
        }),
        createTextboxField({
          key: 'middleName',
          value: '',
          label: 'Middle name',
          rules: {
            required: {},
          },
          order: 11,
          dataType: 'string',
        }),
        createTextboxField({
          key: 'lastName',
          value: '',
          label: 'Last name',
          rules: {
            required: {},
          },
          order: 12,
          dataType: 'string',
        }),
        createTextboxField({
          key: 'nickName',
          value: '',
          label: 'Nickname',
          rules: {
            required: {},
          },
          order: 13,
          dataType: 'string',
        }),
        createDatePickerField({
          key: 'dob',
          value: '',
          label: 'Date of birth',
          rules: {
            required: {},
          },
          order: 14,
          dataType: 'date',
        }),
        createDropdownField({
          key: 'sex',
          value: '',
          label: 'Sex',
          rules: {
            required: {},
          },
          items: [
            { value: 'male', label: 'male' },
            { value: 'female', label: 'female' },
          ],
          order: 15,
          dataType: 'string',
        }),
        createTextboxField({
          key: 'something1',
          value: '',
          label: 'Something1',
          rules: {
            required: {},
          },
          order: 16,
          dataType: 'string',
        }),
        createTextboxField({
          key: 'something2',
          value: '',
          label: 'Something2',
          rules: {
            required: {},
          },
          order: 17,
          dataType: 'string',
        }),
        createTextboxField({
          key: 'something3',
          value: '',
          label: 'Something3',
          rules: {
            required: {},
          },
          order: 18,
          dataType: 'string',
        }),
        createTextboxField({
          key: 'something4',
          value: '',
          label: 'Something4',
          rules: {
            required: {},
          },
          order: 19,
          dataType: 'string',
        }),
        createTextboxField({
          key: 'something5',
          value: '',
          label: 'Something5',
          rules: {
            required: {},
          },
          order: 20,
          dataType: 'string',
        }),
        createTextboxField({
          key: 'something6',
          value: '',
          label: 'Something6',
          rules: {
            required: {},
          },
          order: 21,
          dataType: 'string',
        }),
      ]
    }, { localize: this.localization.getLocalizedResource })

  ];
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/example-form.component.ts